export function normalizeProspectTables(html) {
  if (!html || typeof html !== "string") return html || "";

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");

  doc.querySelectorAll("figure").forEach((figure) => {
    figure.style.margin = "0";
    figure.style.width = "100%";
  });

  doc.querySelectorAll("table").forEach((table) => {
    table.setAttribute("width", "100%");
    table.setAttribute("align", "center");
    table.setAttribute("border", "1");
    table.setAttribute("cellpadding", "0");
    table.setAttribute("cellspacing", "0");

    Object.assign(table.style, {
      width: "100%",
      minWidth: "100%",
      maxWidth: "100%",
      borderCollapse: "collapse",
      border: "1px solid #000",
      tableLayout: "fixed",
      marginLeft: "0",
      marginRight: "0",
      msoTableLspace: "0pt",
      msoTableRspace: "0pt"
    });
  });

  doc.querySelectorAll("th, td").forEach((cell) => {
    cell.setAttribute("align", "center");
    cell.setAttribute("valign", "middle");

    Object.assign(cell.style, {
      textAlign: "center",
      verticalAlign: "middle",
      border: "1px solid #000",
      padding: "5px"
    });
  });

  return doc.body.innerHTML;
}